import { getFormattedHeaderAndTitle } from "./InputRatingUtils";

function buildStandardItem(standard) {
    if (!standard.reportFlag || !standard.included) return null;
    return {
        ...standard,
        contentType: "CDESTANDARD",
        templateContentId: standard.templateContentId,
        label: standard.standardName,
        title: `Standard ${standard.standardName.slice(0, 1)}:`,
        header: standard.standardName.slice(0, 25)
    };
}

function buildGleItem(gle, standard) {
    if (!gle.reportFlag || !gle.included) return null;
    const gleBody = gle.gleName.replace(/^\d+\.\s*/, "");
    return {
        ...gle,
        contentType: "GLE",
        templateContentId: gle.templateContentId,
        label: gleBody,
        header: gleBody.slice(0, 25),
        title: gle.gleShortName,
        standardName: standard.standardName
    };
}

function buildEoItem(eo, gle, standard) {
    if (!eo.reportFlag || !eo.included) return null;
    const { header, shortTitle } = getFormattedHeaderAndTitle(eo.body);
    return {
        ...eo,
        contentType: "EVIDENCE_OUTCOME",
        templateContentId: eo.templateContentId,
        label: eo.body,
        header,
        title: shortTitle,
        gleName: gle.gleName,
        standardName: standard.standardName
    };
}

function buildEocItem(eoc, eo, gle, standard) {
    if (!eoc.reportFlag || !eoc.included) return null;
    const { header, shortTitle } = getFormattedHeaderAndTitle(eoc.body);
    return {
        ...eoc,
        contentType: "EVIDENCE_OUTCOME_CHILD",
        templateContentId: eoc.templateContentId,
        label: eoc.body,
        header,
        title: shortTitle,
        eoName: eo.body,
        gleName: gle.gleName,
        standardName: standard.standardName
    };
}

function processEo(items, eo, gle, standard) {
    const eoItem = buildEoItem(eo, gle, standard);
    if (eoItem) items.push(eoItem);

    eo.evidenceOutcomeChildList?.forEach((eoc) => {
        const eocItem = buildEocItem(eoc, eo, gle, standard);
        if (eocItem) items.push(eocItem);
    });
}

function processGle(items, gle, standard) {
    const gleItem = buildGleItem(gle, standard);
    if (gleItem) items.push(gleItem);

    gle.evidenceOutcomes?.forEach((eo) => processEo(items, eo, gle, standard));
}

function processStandard(items, standard) {
    const standardItem = buildStandardItem(standard);
    if (standardItem) items.push(standardItem);

    standard.gles?.forEach((gle) => processGle(items, gle, standard));
}

export function buildContentItems(selectedTemplate) {
    if (!selectedTemplate?.cdeStandards) return [];
    const items = [];
    selectedTemplate.cdeStandards.forEach((standard) => processStandard(items, standard));
    return items;
}

export function formatName(name) {
    if (!name) return "";
    const [last, first] = name.split(",").map((s) => s.trim());
    return `${first} ${last}`;
}
